import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { movieAction } from '../redux/action/movieAction';
import Banner from '../component/Banner';
import MovieSlide from '../component/MovieSlide';
import BeatLoader from "react-spinners/BeatLoader";


const Home = () => {
  const dispatch = useDispatch();
  const { popularMovies, topRatedMovies, upcomingMovies, nowPlayingMovies ,loading, genreList,Tvseries} = useSelector(state => state.movie);
    // console.log("Home-genreList:", genreList)
  useEffect(() => {
    dispatch(movieAction.getMovies());
  }, []);

  //loading이 true 면 loading스피너를 보여주고
  //loading이 false면 데이터를 보여줌

  // true: 데이터 도착 전 
  // false: 데이터 도착 후/ 에러가 났을 때
  if (loading) {
    return (
      <div className="loader">
        <BeatLoader color="slateblue" loading={loading} width={150} height={10} />
      </div >
    );
  }
  const random = Math.floor(Math.random() * 10)
  return (
    <div className='contents'>
      <Banner movies={nowPlayingMovies.results[random]} />
        <div className='banner_contents'>
          <div className='card_area'>
            <h2>현재 상영작</h2>
            <MovieSlide movies={nowPlayingMovies} />
          </div>
          <div className='card_area'>
            <h2>명작</h2>
            <MovieSlide movies={upcomingMovies} />
          </div>
          <div className='card_area'>
            <h2>인기 영화</h2>
            <MovieSlide movies={popularMovies} />
          </div>
          <div className='card_area'>
            <h2>평점이 높은 영화</h2>
            <MovieSlide movies={topRatedMovies} />
          </div>
        </div>        
    </div>
  )
}

export default Home